import type { UseLeanMutationResult } from '@ztechapps/common.hook'
import { useMutation } from '@ztechapps/common.hook'
import { queries } from '../graphql'
import isEmpty from 'lodash/isEmpty'
import { useDeepCompareEffect } from '@ztechapps/common.hook'
import { useCheckoutContext } from '../index'

export const useUpdateOrder = (): UseLeanMutationResult => {
  //const { activePanel, fromCheckout } = useContext()
  const context = useCheckoutContext()
  const [activePanel] = context.activePanel
  const fromCheckout = context.fromCheckout

  const { document } = context.orderDocumentResult

  const [updateOrder, , mutationResult] = useMutation(queries.updateConfig)

  useDeepCompareEffect(() => {
    if (!isEmpty(document) && document?.checkoutStage !== activePanel && fromCheckout) {
      updateOrder({ input: { _id: document?._id, checkoutStage: activePanel } })
    }
  }, [document, activePanel])

  return [updateOrder, mutationResult]
}
